import { useMemo } from 'react';

export const useEventId = () =>
  useMemo(() => `${new Date().getTime()}_${Math.random().toString().split('.')[1]}`, []);
